import getSuspensionReasons from './get_suspension_reasons';
import makeGetSportSuspensionReasons from './make_get_sport_suspension_reasons';

export default {
  getSuspensionReasons,
  makeGetSportSuspensionReasons,
};
